import React, { useState } from 'react';
import { Modal, Button, Spin, Upload, Image, message } from 'antd';
import get from 'lodash/get';
import map from 'lodash/map';
import { useSelector } from 'react-redux';

import {
  LeftOutlined,
  PlusOutlined,
  InboxOutlined,
  PlayCircleOutlined,
} from '@ant-design/icons';
import { remove } from 'lodash';

const { Dragger } = Upload;

function MediaUploadModal(props) {
  const { media, setMedia } = props;

  const [showMediaModal, setShowMediaModal] = useState(false);
  const [videoPreview, setVideoPreview] = useState({
    visible: false,
    filePath: null,
  });

  const token = useSelector((state) => get(state, 'auth.token'));
  const [loading, setLoading] = useState(false);
  const toggleMediaModal = () => {
    setLoading(false);
    setShowMediaModal(!showMediaModal);
  };

  const beforeUpload = (file) => {
    const isJpgOrPngOrMp4 =
      file.type === 'image/jpeg' ||
      file.type === 'image/png' ||
      file.type === 'video/mp4';
    if (!isJpgOrPngOrMp4) {
      message.error('You can only upload JPG/PNG/mp4 file!');
      return false;
    }
    const isVideo = file.type === 'video/mp4';
    const isLt2M = file.size / 1024 / 1024 <= 2;
    const isLt10M = file.size / 1024 / 1024 <= 10;

    if (isVideo && !isLt10M) {
      message.error('Video must smaller than 10MB!');
      return false;
    }

    if (!isVideo && !isLt2M) {
      message.error('Image must smaller than 2MB!');
      return false;
    }
    return true;
  };

  const handleChange = (info) => {
    if (info.file.status === 'uploading') {
      setLoading(true);
      return;
    }
    if (info.file.status === 'error') {
      setLoading(false);
      return;
    }
    if (info.file.status === 'done') {
      setLoading(false);
      setMedia([...media, get(info, 'file.response.data')]);
    }
  };

  const toggleVideoPreview = (filePath = null) => {
    setVideoPreview({
      visible: !get(videoPreview, 'visible'),
      filePath,
    });
  };

  const onRemoveMedia = (index) => {
    remove(media, (m, i) => i === index);
    setMedia([...media]);
  };

  return (
    <>
      <Button
        className="default-primary-btn"
        type="primary"
        block
        onClick={toggleMediaModal}
      >
        <PlusOutlined /> Upload Image and video
      </Button>
      <Modal
        width="50%"
        className="common-modal product-image-modal "
        destroyOnClose
        closable={false}
        open={showMediaModal}
        onOk={toggleMediaModal}
        onCancel={toggleMediaModal}
        footer={null}
        maskClosable={false}
      >
        <Spin spinning={loading}>
          <div className="login-container">
            <div className="heading">
              <LeftOutlined
                className="back-btn"
                onClick={() => {
                  toggleMediaModal();
                }}
              />
              Upload Images & Videos
            </div>
            <div className="login-form">
              <div className="media-section">
                {map(media, (m, index) => {
                  if (get(m, 'type') === 1) {
                    return (
                      <div className="media-container" key={index}>
                        <Image
                          src={get(m, 'file_path')}
                          className="img-upload-btn"
                          style={{
                            border: ' 1px dashed #d9d9d9',
                          }}
                        />
                        <Button
                          type="link"
                          onClick={() => {
                            onRemoveMedia(index);
                          }}
                        >
                          Delete
                        </Button>
                      </div>
                    );
                  }

                  return (
                    <div className="media-container">
                      <div className="img-upload-btn">
                        <PlayCircleOutlined
                          className="table-icon"
                          onClick={() => {
                            toggleVideoPreview(get(m, 'file_path'));
                          }}
                        />
                      </div>
                      <Button
                        type="link"
                        onClick={() => {
                          onRemoveMedia(index);
                        }}
                      >
                        Delete
                      </Button>
                    </div>
                  );
                })}

                {media.length !== 0 && (
                  <Upload
                    name="file"
                    listType="picture-card"
                    beforeUpload={beforeUpload}
                    className="avatar-uploader"
                    showUploadList={false}
                    action={process.env.REACT_APP_IMAGE_URL}
                    headers={{ authorization: `Bearer ${token}` }}
                    data={{ action: 'upload_file' }}
                    onChange={handleChange}
                  >
                    <div>
                      <PlusOutlined />
                      <div style={{ marginTop: 8 }}>Upload</div>
                    </div>
                  </Upload>
                )}
              </div>

              {media.length === 0 && (
                <Dragger
                  name="file"
                  className="dragger"
                  showUploadList={false}
                  multiple
                  action={process.env.REACT_APP_IMAGE_URL}
                  headers={{ authorization: `Bearer ${token}` }}
                  data={{ action: 'upload_file' }}
                  onChange={handleChange}
                  beforeUpload={beforeUpload}
                >
                  <>
                    <p className="ant-upload-drag-icon">
                      <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">
                      Drag or Drop file to this area to upload
                    </p>
                    <p className="ant-upload-text">Or</p>
                  </>

                  <Button type="primary" className="default-primary-btn mt-40">
                    Browse
                  </Button>
                </Dragger>
              )}
            </div>
            <div className="mt-80 instruction">
              <ul>
                <li>Images Size should not more than 2 MB</li>
                <li>360 degree video should not more than 10 MB</li>
              </ul>
            </div>
          </div>
        </Spin>
      </Modal>
      <Modal
        width="50%"
        destroyOnClose
        open={get(videoPreview, 'visible')}
        onOk={toggleVideoPreview}
        onCancel={toggleVideoPreview}
        footer={null}
        className="video-preview-modal"
      >
        <video width="100%" height="300" controls>
          <source src={get(videoPreview, 'filePath')} type="video/mp4" />
          <track
            src="captions_en.vtt"
            kind="captions"
            srcLang="en"
            label="english_captions"
          />
        </video>
      </Modal>
    </>
  );
}

export default MediaUploadModal;
